import { Buildings } from '@phosphor-icons/react';
import styled from 'styled-components';
import etfIcon from '../../../../../../src/assets/iconETFs.png';

const Row = styled.div`
  display: grid;
  grid-template-columns: 2.2fr 1fr 1fr 1fr 1.4fr;
  align-items: center;
  gap: 1rem;
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    background: #f8fafc;
  }
`;

const AssetImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  transform: scale(1.4);
`;

const AssetInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
`;

const IconBox = styled.div`
  width: 55px;
  height: 55px;
  padding: 4px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
  background: #ffffff;
`;

const AssetText = styled.div`
  min-width: 0;

  strong {
    display: block;
    color: #111827;
    font-size: 0.95rem;
  }

  span {
    display: block;
    color: #64748b;
    font-size: 0.82rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 210px;
  }
`;

const Cell = styled.div`
  font-size: 0.9rem;
  color: #111827;
  text-align: center;
`;

const PositiveBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.55rem;
  border-radius: 999px;
  background: #d8f8ef;
  color: #009879;
  font-weight: 500;
`;

function formatPercent(value) {
  if (value === null || value === undefined || value === '') return '-';

  const number = Number(value);

  if (Number.isNaN(number)) return '-';

  return `${number.toFixed(2).replace('.', ',')}%`;
}

function formatMarketCap(value) {
  if (!value) return '-';

  const number = Number(value);

  if (Number.isNaN(number)) return '-';

  if (number >= 1_000_000_000_000) {
    return `${(number / 1_000_000_000_000).toFixed(2).replace('.', ',')} T`;
  }

  if (number >= 1_000_000_000) {
    return `${(number / 1_000_000_000).toFixed(2).replace('.', ',')} B`;
  }

  if (number >= 1_000_000) {
    return `${(number / 1_000_000).toFixed(2).replace('.', ',')} M`;
  }

  return number.toLocaleString('pt-BR');
}

export function CardEtfRank({ etf, selectedActive }) {


  return (
    <Row
      onClick={() =>
        selectedActive({
          slug: etf.ticker,
          type: 'etf',
        })
      }
    >
      <AssetInfo>
        <IconBox>
          <AssetImage
            src={etfIcon}
            alt="ETF"
          />
        </IconBox>
        {/* <div
          style={{
            position: 'absolute',
            right: '10px',
            top: '10px',
            opacity: 0.08,
            fontSize: '6rem',
            fontWeight: 900,
            color: '#EC6643',
          }}
        >
          ETF
        </div> */}
        <AssetText>
          <strong>{etf.ticker}</strong>
          <span title={etf.name}>{etf.name}</span>
        </AssetText>
      </AssetInfo>

      <Cell>
        {formatPercent(
          etf.latest_kpi?.dy ??
            etf.latest_kpi?.avg_dy ??
            etf.dividend_yield
        )}
      </Cell>

      <Cell>
        {formatMarketCap(
          etf.latest_kpi?.market_cap ??
            etf.market_cap ??
            etf.capitalization
        )}
      </Cell>

      <Cell>
        <PositiveBadge>
          {formatPercent(etf.variation_12m)}
        </PositiveBadge>
      </Cell>

      <Cell>
        {etf.holdings_count ?? etf.holdings?.length ?? '-'}
      </Cell>
    </Row>
  );
}